import { ICollectionPoint,
         ICollectionPointOperator,
         ICollectionPointOperatorAdd,
         ICollectionPointUpdate,
         ICrossReference } from '../util/DataModelInterface';
import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getCollectionpointOperators = async (force: boolean = false) => {
  let operators = storage.getCollectionpointOperators();
  let points = await getAllCollectionpointInfo(force);
  if (!operators || operators.length === 0 || force) {
    const url = `${getFunctionBaseUrl()}/api/collectionpointOperators`;
    const response = await rest.get(url);
    operators = response as ICollectionPointOperator[];
    if(operators) {
      operators.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      });
      operators.forEach((op: ICollectionPointOperator) => {
        if(points)
          op.collection_points  = points.filter(point => point.info.operator_id === op.id);
      });
    }
    storage.setCollectionpointOperators(operators);
  }
  return operators;
}

const mapCrossreferences = (crossrefs: any[]): ICrossReference[] => {
  let refs: ICrossReference[] = [];
  for(var key in crossrefs) {
    const ref: ICrossReference = { sorter_name: key, references: crossrefs[key] };
    refs.push(ref);
  }
  return refs;
}

export const getAllCollectionpointInfo = async (force: boolean = false) => {
  let points = storage.getCollectionpoints();
  if (!points || points.length === 0 || force) {
    const url = `${getFunctionBaseUrl()}/api/getCollectionpointInfo/all`;
    const response = await rest.get(url);
    points = response as ICollectionPoint[];
    if(points && points.length>0) {
      points.forEach((p: ICollectionPoint, i) => {
        p.crossreferences = mapCrossreferences(response[i].crossreferences);
      });
    }
    storage.setCollectionpoints(points);
  }
  return points;
}

export const updateCollectionpointInfo = async (info: ICollectionPointUpdate) => {
  const url = `${getFunctionBaseUrl()}/api/updateCollectionpointInfo`;
  const response = await rest.post(url, info);
  return response;
}

export const addNewCollectionpoint = async (data: ICollectionPointUpdate) => {
  const url = `${getFunctionBaseUrl()}/api/addCollectionpoint`;
  const response = await rest.post(url, data);
  return response;
}

export const updateCollectionpointOperator = async (data: ICollectionPointOperator) => {
  const url = `${getFunctionBaseUrl()}/api/updateCollectionpointOperator`;
  const response = await rest.post(url, data);
  return response;
}

export const addCollectionpointOperator = async (data: ICollectionPointOperatorAdd) => {
  const url = `${getFunctionBaseUrl()}/api/addOperator`;
  const response = await rest.post(url, data);
  return response;
}

export const emptyPoint = (store = false) => {
  return { info: {  collectionpoint_id: "", name: "", operator_id: "", public_id: "", operational_state: "InUse",
                    location_lat: "", location_lon: "", street_address: "", zip_code: "", city: "",
                    community: "", contact_info: "", dataser: false, store_point: store, container_point: true }, 
           crossreferences: []} as ICollectionPoint;
}

export const emptyPointUpdate = (store = false) => {
  return { info: {  collectionpoint_id: "", name: "", operator_id: "", public_id: "", operational_state: "InUse",
                    location_lat: "", location_lon: "", street_address: "", zip_code: "", city: "",
                    community: "", contact_info: "", dataser: false, store_point: store, container_point: true}, 
           crossreferences: [], collectionpoint_exists: false } as ICollectionPointUpdate;
}
